import { Injectable } from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpHandler,
  HttpEvent,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';

import { ApplicationConfigService } from '../config/application-config.service';
import { environment } from 'src/environments/environment';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  constructor(
    private localStorageService: LocalStorageService,
    private sessionStorageService: SessionStorageService,
    private applicationConfigService: ApplicationConfigService
  ) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    const serverApiUrl = this.applicationConfigService.getEndpointFor('');
    if (
      !request.url ||
      (request.url.startsWith('http') && !request.url.startsWith(serverApiUrl))
    ) {
      return next.handle(request);
    }

    const token: string | null =
      this.localStorageService.retrieve('authenticationToken') ??
      this.sessionStorageService.retrieve('authenticationToken');
    if (request?.url?.includes(environment.SERVER_API_URL)) {
      if (token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${token}`,
            'X-TenantID': this.localStorageService.retrieve('tenantId'),
            'X-Client-Offset': new Date().getTimezoneOffset().toString(),
          },
        });
      } else {
        request = request.clone({
          setHeaders: {
            'X-TenantID': this.localStorageService.retrieve('tenantId'),
            'X-Client-Offset': new Date().getTimezoneOffset().toString(),
          },
        });
      }
    }
    return next.handle(request);
  }
}
